// eslint-disable-next-line no-restricted-imports
import styled from 'styled-components/macro';

export const Time = styled.div`
  width: 120px !important;
  font-size: 14px;
  background-color: var(--secondary);
  color: var(--white);
  padding: 8px 10px;
  border-radius: 5px;
  text-align: center;
`;
